import {
  useQuery,
  UseQueryResult,
  UseQueryOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import { buildQueryString } from "@mimber-client/utils"
import type {
  CommunicationTemplateDto,
  ResponseDto,
  QueryParamsDto,
} from "@mimber/schema"
import { communicationTemplatesKeys } from "../communication-templates.utils"

export type UseCommunicationTemplatesParams = QueryParamsDto

export const useCommunicationTemplates = (
  params?: UseCommunicationTemplatesParams,
  options?: UseQueryOptions<ResponseDto<CommunicationTemplateDto[]>, Error>
): UseQueryResult<ResponseDto<CommunicationTemplateDto[]>, Error> => {
  guardAppUsage("mimber-organization", "useCommunicationTemplates")

  const { server } = useServerContext()

  return useQuery({
    queryKey: communicationTemplatesKeys.findAll(params),
    queryFn: async () => {
      const response = await server.get<
        ResponseDto<CommunicationTemplateDto[]>
      >(buildQueryString("communication-templates", params))
      return response.data
    },
    staleTime: 1 * 60 * 1000,
    ...options,
  })
}
